import { render, staticRenderFns } from "./FCSwiperProgressBar.vue?vue&type=template&id=ec7d00fa&scoped=true&"
import script from "./FCSwiperProgressBar.vue?vue&type=script&lang=ts&"
export * from "./FCSwiperProgressBar.vue?vue&type=script&lang=ts&"
import style0 from "./FCSwiperProgressBar.vue?vue&type=style&index=0&id=ec7d00fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7d00fa",
  null
  
)

export default component.exports